import { createRouter, createWebHashHistory } from "vue-router";
import { sso } from "roboflex-thalamus-sso-lib";
import { getPermissao } from "@/services/permissaoService";
import AcessoView from "../views/Acesso/AcessoView.vue";
import VisitanteView from "../views/Acesso/VisitanteView.vue";
import VisitanteCadastro from "../views/Acesso/VisitanteCadastro.vue";
import PesquisaView from "../views/Acesso/PesquisaView.vue";
import SolicitacaoVisitaView from "../views/Visitantes/SolicitacaoVisitaView.vue";
import ListaSolicitacoesView from "../views/Visitantes/ListaSolicitacoesView.vue";
import CheckListAcessoView from "../views/Visitantes/CheckListAcessoView.vue";
import AgendaVisitasView from "../views/Visitantes/AgendaVisitasView.vue";
import ListaCheckinDiaView from "../views/Visitantes/ListaCheckinDiaView.vue";
import MeusPedidosView from "../views/Visitantes/MeusPedidosView.vue";
import DadosCompletosVisitanteView from "../views/Visitantes/DadosCompletosVisitanteView.vue";
import DadosCompletosVisitaView from "../views/Visitantes/DadosCompletosVisitaView.vue";
import HistoricoVisitasView from "../views/Visitantes/HistoricoVisitasView.vue";
import ListaVisitantesView from "../views/Visitantes/ListaVisitantesView.vue";
import AgendaSalaView from "../views/SalasReuniao/AgendaSalaView.vue";
import MosaicoSalasView from "../views/SalasReuniao/MosaicoSalasView.vue";
import MosaicoSalas2View from "../views/SalasReuniao/MosaicoSalas2View.vue";
//Permissão
import ColaboradorView from "@/views/Permissão/ColaboradorView";
import ControleDeColaboradorRH from "@/views/Permissão/ControleDeColaborador";
import ColaboradorRecepcaoView from "@/views/Permissão/ColaboradorRecepcaoView";

/** Login do portal Thalamus — mesmo padrão que dados-basicos / demandas (`VUE_APP_ROOT_SSO_LOGIN`). */
function redirectToSsoLogin() {
  const url = (process.env.VUE_APP_ROOT_SSO_LOGIN || "").trim();
  if (url) {
    document.location = url;
    return;
  }
  if (process.env.NODE_ENV === "production") {
    document.location = "https://portal.thalamus.ind.br/#/login";
  } else {
    document.location = "http://portal-homologacao.thalamus.ind.br/#/login";
  }
}

function guardMyroute(to, from, next) {
  if (sso.validarSessao()) {
    next();
  } else {
    redirectToSsoLogin();
  }
}

async function guardPermissao(to, from, next) {
  const permissoes = await getPermissao();
  const funcionalidadeNecessaria = to.meta.funcionalidadeId;
  const semPermissao = funcionalidadeNecessaria
    ? Array.isArray(funcionalidadeNecessaria)
      ? !funcionalidadeNecessaria.some((id) => permissoes.includes(id))
      : !permissoes.includes(funcionalidadeNecessaria)
    : false;
  if (semPermissao) {
    redirectToSsoLogin();
    return;
  }
  next();
}

function guardPermissaoRoute(to, from, next) {
  guardMyroute(to, from, (guardResultado) => {
    if (guardResultado !== undefined) {
      next(guardResultado);
    } else {
      guardPermissao(to, from, next);
    }
  });
}

const routes = [
  //Acesso
  {
    path: "/acesso",
    name: "AcessoView",
    component: AcessoView,
    beforeEnter: guardMyroute,
  },
  {
    path: "/visitante",
    name: "VisitanteView",
    component: VisitanteView,
    beforeEnter: guardPermissaoRoute,
  },
  {
    path: "/visitante/novo",
    name: "VisitanteCadastro",
    component: VisitanteCadastro,
    beforeEnter: guardPermissaoRoute,
  },
  {
    path: "/visitante/editar/:id",
    name: "EditarVisitante",
    component: VisitanteCadastro,
    beforeEnter: guardPermissaoRoute,
  },
  {
    path: "/pesquisa",
    name: "PesquisaView",
    component: PesquisaView,
    beforeEnter: guardPermissaoRoute,
  },
  {
    path: "/solicitacoes",
    name: "ListaSolicitacoes",
    component: ListaSolicitacoesView,
    meta: { funcionalidadeId: 256 },
    beforeEnter: guardPermissaoRoute,
  },
  {
    path: "/solicitacao-visita/novo",
    name: "SolicitacaoVisitaNova",
    component: SolicitacaoVisitaView,
    beforeEnter: guardMyroute,
  },
  {
    path: "/solicitacao-visita/editar/:id",
    name: "SolicitacaoVisitaEditar",
    component: SolicitacaoVisitaView,
    beforeEnter: guardMyroute,
  },
  {
    path: "/acesso/checklist/:id",
    name: "CheckListAcesso",
    component: CheckListAcessoView,
    beforeEnter: guardMyroute,
  },
  {
    path: "/acesso/checkin-dia",
    name: "ListaCheckinDia",
    component: ListaCheckinDiaView,
    meta: { funcionalidadeId: 256 },
    beforeEnter: guardPermissaoRoute,
  },
  {
    path: "/acesso/visita/:id/dados-completos",
    name: "DadosCompletosVisitante",
    component: DadosCompletosVisitanteView,
    beforeEnter: guardMyroute,
  },
  {
    path: "/acesso/visita/:id/dados-completos-visita",
    name: "DadosCompletosVisita",
    component: DadosCompletosVisitaView,
    beforeEnter: guardMyroute,
  },
  {
    path: "/acesso/visita/:id/historico",
    name: "HistoricoVisitas",
    component: HistoricoVisitasView,
    beforeEnter: guardMyroute,
  },
  {
    path: "/visitantes",
    name: "ListaVisitantes",
    component: ListaVisitantesView,
    meta: { funcionalidadeId: 256 },
    beforeEnter: guardPermissaoRoute,
  },
  {
    path: "/agenda-sala",
    name: "AgendaSala",
    component: AgendaSalaView,
    // Display na porta: autentica por token de kiosk (sem SSO)
  },
  {
    path: "/mosaico-salas",
    name: "MosaicoSalas",
    component: MosaicoSalasView,
    // Mosaico da TV: rota aberta, só lista o status das salas ativas
  },
  {
    path: "/mosaico-salas2",
    name: "MosaicoSalas2",
    component: MosaicoSalas2View,
    // Mosaico novo da TV: rota aberta, mesmo dado da versão anterior
  },
  {
    path: "/",
    name: "AgendaVisitas",
    component: AgendaVisitasView,
    beforeEnter: guardMyroute,
  },
  {
    path: "/anfitriao/informar-visitante",
    redirect: { path: "/solicitacao-visita/novo" },
  },
  {
    path: "/anfitriao/meus-pedidos",
    name: "MeusPedidos",
    component: MeusPedidosView,
    beforeEnter: guardMyroute,
  },

  //Permissão
  {
    path: "/colaboradores-rh",
    name: "ControleDeColaboradorRH",
    component: ControleDeColaboradorRH,
    beforeEnter: guardPermissaoRoute,
  },
  {
    path: "/colaboradores/novo",
    name: "AdicionarColaborador",
    component: ColaboradorView,
    title: "Adicionar Colaborador",
    beforeEnter: guardPermissaoRoute,
  },
  {
    path: "/colaboradores/editar/:id",
    name: "ColaboradorEditar",
    component: ColaboradorView,
    title: "Editar Colaborador",
    beforeEnter: guardPermissaoRoute,
  },
  {
    path: "/colaboradores/excluir",
    name: "ExcluirColaborador",
    component: ColaboradorView,
    title: "Excluir Colaborador",
    beforeEnter: guardPermissaoRoute,
  },
  {
    path: "/colaboradores",
    name: "ControleDeColaborador",
    component: ColaboradorRecepcaoView,
    title: "Colaborador Recepção",
    beforeEnter: guardPermissaoRoute,
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

export default router;
